import React from 'react'
import Icon from 'particles/Icon'
import Text from 'particles/Text'
import { useNewTranslation } from 'hooks'
import styled from 'particles/themes/styled'
import { SubmissionProgressProps } from 'state/review'
import { backendDateToJsDate, parseBackendDate } from 'services/dates'
import { Country } from 'services/api/constants'
import { format } from 'date-fns'

interface ReviewedByDisplayProps {
    country: Country
    submissionProgress?: SubmissionProgressProps
}

export const ReviewedByDisplay = ({ submissionProgress, country }: ReviewedByDisplayProps) => {
    const [newT] = useNewTranslation()

    if (!submissionProgress) return null

    const { moved_out_of_pending_at, moved_out_of_pending_by } = submissionProgress
    const reviewerName = moved_out_of_pending_by?.name
    if (!reviewerName || !moved_out_of_pending_at) return null

    const date = parseBackendDate(moved_out_of_pending_at, country)
    const time = format(backendDateToJsDate(moved_out_of_pending_at), 'h:mm aa')

    return (
        <ReviewedByContainer>
            <Icon name="pencilLine" size="16px" />
            <Text scale="caption400" style={{ textAlign: 'left' }}>
                {newT('card.submission.lastReviewedLabel', {
                    latestReviewerName: reviewerName,
                    // TODO: ask if possible for copy combined date & time for consistency
                    date,
                    time,
                })}
            </Text>
        </ReviewedByContainer>
    )
}

const ReviewedByContainer = styled.div`
    display: flex;
    gap: 4px;
    margin-top: 12px;
`
